import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';

export default (reducers: any) => {
  const persistedReducer = persistReducer(
    {
      key: 'root',
      storage,
      whitelist: [
        'config',
        'auth',
        'contacts',
        'contactsByCpf',
        'contract',
        'proposal',
        'agreement',
        'analytic',
        'negotiation',
        'addresses'
      ],
      blacklist: ['networkError'],
    },
    reducers
  );

  return persistedReducer;
};
